const config = {
  environment: process.env.NODE_ENV || 'development',
  port: process.env.PORT || 8023,
  host: process.env.HOST,
  orgApiKey: process.env.ORG_API_KEY || '',
  orgId: process.env.ORG_ID || '',
  sdkHost: process.env.CUSTOMER_WEB_BASE_URL || 'http://localhost:8023/dist',
  sdkVersion: process.env.SDK_VERSION || 'v1.1',
  pusherAPIKey: process.env.PUSHER_API_KEY || '',
  apiBaseUrl: process.env.API_BASE_URL || 'http://api.kustomer.test:8000/v1',
};

const overrides = {};

try {
  const useHttps = process.argv.slice(2)[0] === '--useHttps';

  if (useHttps) {
    const hasKeys =
      process.env.DEV_STAGING_CUSTOMER_WEB_BASE_URL &&
      process.env.DEV_STAGING_PUSHER_ACCESS_KEY &&
      process.env.DEV_STAGING_PORT &&
      process.env.DEV_STAGING_HOST &&
      process.env.DEV_STAGING_API_BASE_URL;

    if (hasKeys) {
      overrides.port = parseInt(process.env.DEV_STAGING_PORT, 10);
      overrides.host = process.env.DEV_STAGING_HOST;
      overrides.sdkHost = process.env.DEV_STAGING_CUSTOMER_WEB_BASE_URL;
      overrides.pusherAPIKey = process.env.DEV_STAGING_PUSHER_ACCESS_KEY;
      overrides.apiBaseUrl = process.env.DEV_STAGING_API_BASE_URL;
    } else {
      console.log('start:https failed. Please add all necessary env vars.'); // eslint-disable-line no-console
      process.exit(1);
    }
  }
} catch (e) {
  console.log('Error using https', e); // eslint-disable-line no-console
}

module.exports = Object.assign({}, config, overrides);
